module.exports = __webpack_public_path__ + "img/data-item2.4eaa2417.png";